import React from "react";

export const SunnyIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="32" fill="#3F4447">
                <g transform="translate(2.000000, 2.000000)">
                    <rect
                        transform="translate(70.500000, 38.000000) rotate(-270.000000) translate(-70.500000, -38.000000) "
                        x="69"
                        y="33"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(5.500000, 38.000000) rotate(-270.000000) translate(-5.500000, -38.000000) "
                        x="4"
                        y="33"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(61.500000, 62.000000) rotate(-225.000000) translate(-61.500000, -62.000000) "
                        x="60"
                        y="57"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(14.500000, 15.000000) rotate(-225.000000) translate(-14.500000, -15.000000) "
                        x="13"
                        y="10"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(38.500000, 71.000000) rotate(-180.000000) translate(-38.500000, -71.000000) "
                        x="37"
                        y="66"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(38.500000, 5.000000) rotate(-180.000000) translate(-38.500000, -5.000000) "
                        x="37"
                        y="0"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(14.500000, 62.000000) rotate(-135.000000) translate(-14.500000, -62.000000) "
                        x="13"
                        y="57"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(61.500000, 15.000000) rotate(-135.000000) translate(-61.500000, -15.000000) "
                        x="60"
                        y="10"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <path
                        d="M37.5,61.5 C24.7896345,61.5 14.5,50.9710716 14.5,38 C14.5,25.0289284 24.7896345,14.5 37.5,14.5 C50.2103655,14.5 60.5,25.0289284 60.5,38 C60.5,50.9710716 50.2103655,61.5 37.5,61.5 Z M37.5,58.5 C48.5378788,58.5 57.5,49.3294573 57.5,38 C57.5,26.6705427 48.5378788,17.5 37.5,17.5 C26.4621212,17.5 17.5,26.6705427 17.5,38 C17.5,49.3294573 26.4621212,58.5 37.5,58.5 Z"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </svg>
);
